import { Checkbox, TableCellProps } from '@material-ui/core';
import React from 'react';
import { TableHeaderCell } from './TableHeaderCell';

export type TableHeaderCheckboxCellProps = Omit<TableCellProps, "children"> & {
    selectedCount: number
    totalCount: number
    onSelectAll: (checked: boolean) => void
}

export function TableHeaderCheckboxCell ({selectedCount, totalCount, onSelectAll, ...props}: TableHeaderCheckboxCellProps) {
    return (
        <TableHeaderCell padding="checkbox" {...props}>
            <Checkbox
                indeterminate={selectedCount > 0 && selectedCount < totalCount}
                checked={totalCount > 0 && selectedCount === totalCount}
                onChange={(_, c) => onSelectAll(c)}
            />
        </TableHeaderCell>
    )
}
